const apiUrl = import.meta.env.VITE_API_URL || '';

export const env = {
  // URLs
  BASE_URL:
    import.meta.env.VITE_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : ''),
  API_URL: apiUrl,

  // API (derived from VITE_API_URL)
  API_BASE_URL: apiUrl ? `${apiUrl.replace(/\/+$/, '')}/api` : '/api',
  API_VERSION: import.meta.env.VITE_API_VERSION || 'v1',

  // Feature Flags
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ENABLE_MOCK_API: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
  // Route billing checkout/portal to the REAL BE even while reads are mocked —
  // lets the billing page render on fixtures while the LTD button hits real Stripe.
  BILLING_LIVE_CHECKOUT: import.meta.env.VITE_BILLING_LIVE_CHECKOUT === 'true',
  // Per-endpoint mock fallback for the billing READS: hit the real BE first and
  // only serve a fixture when the route returns 404 (not deployed yet). On by
  // default; opt out with VITE_BILLING_MOCK_FALLBACK=false. Only ever applied in
  // DEV builds (see billingApi.ts) — never in production/staging.
  BILLING_MOCK_FALLBACK: import.meta.env.VITE_BILLING_MOCK_FALLBACK !== 'false',
  ENABLE_DEV_TOOLS: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',

  // Third-party
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || '',

  // OAuth
  LINKEDIN_CLIENT_ID: import.meta.env.VITE_LINKEDIN_CLIENT_ID || '',
  TWITTER_CLIENT_ID: import.meta.env.VITE_TWITTER_CLIENT_ID || '',

  // Socket
  SOCKET_URL: import.meta.env.VITE_SOCKET_URL || '',

  // tawk.to
  TAWK_PROPERTY_ID: import.meta.env.VITE_TAWK_PROPERTY_ID || '',
  TAWK_WIDGET_ID: import.meta.env.VITE_TAWK_WIDGET_ID || '',

  // Help Center
  HELP_CENTER_URL: import.meta.env.VITE_HELP_CENTER_URL || '',

  // Computed
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,
} as const;

export type Env = typeof env;
